<template>
    <div>
        <div class="mb-4">
            <div class="font-weight-bolder mb-2">{{ dataTexts.system_of_unit }}</div>
            <span class="button button-small px-2" :class="{'disabled': unitSystem == 'imperial', 'btn-danger': unitSystem == 'metrics'}" @click="convert('imperial')">Imperial</span>
            <span class="button button-small px-2" :class="{'disabled': unitSystem == 'metrics', 'btn-danger': unitSystem == 'imperial'}" @click="convert('metrics')">Metrics</span>
        </div>
        <div id="comparison_table">
            <div class="d-flex overflow-auto pb-3">
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="row">
                        <div class="col"></div>
                        <div class="col text-center py-2 font-weight-bold bg-bva text-white h5 m-0">{{ mainProduct.ref }}</div>
                    </div>
                        <div v-for="(attribute, index) in mainProduct.not_highlight_attributes" :key="attribute.id" :class="{'bg-white': index % 2 == 0}"
                        class="row">
                            <div class="col font-weight-bold attribute-name">{{ attribute.name }}</div>
                            <div class="col text-center py-2 bg-bva text-white font-weight-bold comparison-table-cell"
                                :class="{'bg-bva light': index % 2 == 0, 'border-bottom': index+1 == mainProduct.not_highlight_attributes.length}"
                            >
                                {{ attribute.pivot.value+' '+(attribute.unit ? attribute.unit : '') }}
                            </div>
                        </div>
                </div>
                <div v-for="comparisonProduct in mainProduct.objects_comparison_products" :key="comparisonProduct.id" class="col-5 col-md-3 col-lg-2 text-center">
                    <div class="row">
                        <div class="col text-center py-2 font-weight-bold h5 m-0">{{ comparisonProduct.ref }}</div>
                    </div>
                    <div v-for="(attribute, index) in mainProduct.not_highlight_attributes" :key="attribute.id" :class="{'bg-white': index % 2 == 0}" class="row">
                        <div class="col comparison-table-cell">
                            {{ comparisonProduct.not_highlight_attributes.find((att) => att.id == attribute.id)
                                ? comparisonProduct.not_highlight_attributes.find((att) => att.id == attribute.id).pivot.value+' '+(attribute.unit ? attribute.unit : '')
                                : ' - '
                             }}
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col">
                            <a :href="'/product/'+comparisonProduct.ref">{{ dataTexts.view_product }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "dataTexts",
        "dataImperialToMetrics",
        "dataMainProduct",
    ],
    data() {
        return {
            mainProduct: JSON.parse(JSON.stringify(this.dataMainProduct)),
            unitSystem: 'imperial'
        };
    },
    methods: {
        convert(unitSystem) {
            this.unitSystem = unitSystem
            if (unitSystem == 'metrics') {
                // convert to metrics system
                [this.mainProduct, ...this.mainProduct.objects_comparison_products].forEach(product => {
                    product.not_highlight_attributes.forEach(attribute => {
                        if (_.toNumber(attribute.pivot.value) && (attribute.unit in this.dataImperialToMetrics)) {
                            var convertedValue = this.dataImperialToMetrics[attribute.unit]['coef'] * attribute.pivot.value
                            if (this.dataImperialToMetrics[attribute.unit]['decimals']) {
                                convertedValue = convertedValue.toFixed(this.dataImperialToMetrics[attribute.unit]['decimals'])
                            } else {
                                convertedValue = Math.round(convertedValue * 100) / 100
                            }
                            attribute.pivot.value = convertedValue
                            attribute.unit = this.dataImperialToMetrics[attribute.unit]['unit']
                        }
                    })
                })
            } else {
                // reset table
                this.mainProduct = JSON.parse(JSON.stringify(this.dataMainProduct))
                this.comparisonProducts = JSON.parse(JSON.stringify(this.dataComparisonProducts))
            }
        }
    },
};
</script>
